import { colors } from 'helpers/ColorHelper';

import styled from 'styled-components';

export const StyledFooterText = styled.div`
  text-align: center;
  color: ${colors.$BLUE_GREY};
  margin-top: 10px;
`;
